export function replaceCBValueBasedOnPrompt(data, prompt, newValue) {
  for (let item of data) {
    let output = item.payload.output;
    for (let outputItem of output) {
      if (outputItem.name === "prompt" && outputItem.value === prompt) {
        if (item.payload.input.length > 0) {
          item.payload.input[0].value = newValue;
          return true;
        }
      }
    }
  }
  return false;
}

export function replacePayloadCBValueBasedOnPrompt(data, prompt, newValue) {
  for (const item of data) {
    let output = item.output;
    let input = item.input;
    for (const outputItem of output) {
      if (outputItem.name === "prompt" && outputItem.value === prompt) {
        if (input.length > 0) {
          input[0].value = newValue;
          break;
        }
      }
    }
  }
}
